export { default } from './Hero';
export type { HeroProps, HeroClassKey, HeroClasses } from './Hero.types';
